import { render, staticRenderFns } from "./ItineraryMain.vue?vue&type=template&id=4f9a6978"
import script from "./ItineraryMain.vue?vue&type=script&lang=ts"
export * from "./ItineraryMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports